export default __webpack_public_path__ + "static/media/cuberun-logo.2a67aff7.png";